import { render, staticRenderFns } from "./TopBottomButton.vue?vue&type=template&id=0b7ffe7e&scoped=true&"
import script from "./TopBottomButton.vue?vue&type=script&lang=js&"
export * from "./TopBottomButton.vue?vue&type=script&lang=js&"
import style0 from "./TopBottomButton.vue?vue&type=style&index=0&id=0b7ffe7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ffe7e",
  null
  
)

export default component.exports